export const AGE_GROUPS = [
  {
    label: {
      en: 'Under 18',
      de: '0 - 18 Jahre',
    },
    value: '1',
  },
  {
    label: {
      en: 'Age between 19 - 25',
      de: '19 - 25 Jahre',
    },
    value: '2',
  },
  {
    label: {
      en: 'Over 26',
      de: 'ab 26 Jahre',
    },
    value: '3',
  },
];

export const INSURANCE_MODELS = [
  {
    value: 'TAR-HAM',
    label: {
      en: 'Family Doctor',
      de: 'Hausarzt',
    },
    code: 2,
  },
  {
    value: 'TAR-HMO',
    label: {
      en: 'HMO',
      de: 'HMO',
    },
    code: 3,
  },
  {
    value: 'TAR-DIV',
    label: {
      en: 'Telmed',
      de: 'Telmed',
    },
    code: 1,
  },
  {
    value: 'TAR-BASE',
    label: {
      en: 'Standard',
      de: 'Standard',
    },
    code: 0,
  },
];

export const ACCIDENT_COVERAGE_OPTIONS = [
  {
    label: 'mit',
    value: true,
  },
  {
    label: 'ohne',
    value: false,
  },
];

export const FRANCHISE_OPTIONS = [
  {
    label: '300 CHF',
    value: 300,
  },
  {
    label: '500 CHF',
    value: 500,
  },
  {
    label: '1000 CHF',
    value: 1000,
  },
  {
    label: '1500 CHF',
    value: 1500,
  },
  {
    label: '2000 CHF',
    value: 2000,
  },
  {
    label: '2500 CHF',
    value: 2500,
  },
];

export const CHILD_FRANCHISE_OPTIONS = [
  {
    label: '0 CHF',
    value: 0,
  },
  {
    label: '100 CHF',
    value: 100,
  },
  {
    label: '200 CHF',
    value: 200,
  },
  {
    label: '300 CHF',
    value: 300,
  },
  {
    label: '400 CHF',
    value: 400,
  },
  {
    label: '500 CHF',
    value: 500,
  },
  {
    label: '600 CHF',
    value: 600,
  },
];

export const DEFAULT_INSURANCE_COMPANY = {
  shortName: 'Kein Vorversicherer',
  insuranceCompanyName: 'Kein Vorversicherer',
  groupName: 'Others',
  groupId: -2,
  doctorListUrl: null,
  logoUrl: null,
};

export const DEFAULT_PERSON = {
  birthDate: '',
  accidentCoverage: true,
  insuranceModel: 0,
  ageGroup: '3',
  franchise: 2500,
  currentInsuranceCompany: DEFAULT_INSURANCE_COMPANY,
  region: {},
  offers: [],
  doctors: [],
  doctor: '',
  collapsed: false,
  franchiseOptions: {
    child: CHILD_FRANCHISE_OPTIONS,
    adult: FRANCHISE_OPTIONS,
  },
};

export const LANGUAGE_CODES = {
  en: 914650000,
  de: 914650001,
  fr: 914650002,
  it: 914650003,
};

export const APP_IDS = {
  sourceId: 'c8b8b9e1-4d77-ea11-a811-000d3ada40bc',
  calculatorId: '0daa47e5-1858-4552-a8bc-f64af3d18222',
};

export const INSURANCE_CONTRACT_YEARS = [1, 2, 3, 4, 5];

export const CIVIL_STATUSES = [
  {
    label: {
      en: 'Single',
      de: 'Single',
      fr: 'Célibataire',
      it: 'Singolo',
    },
    value: 1,
  },
  {
    label: {
      en: 'Married',
      de: 'Verheiratet',
      fr: 'Mariée',
      it: 'Sposata',
    },
    value: 2,
  },
  {
    label: {
      en: 'Divorced',
      de: 'Geschieden',
      fr: 'Divorcée',
      it: 'Divorziata',
    },
    value: 3,
  },
  {
    label: {
      en: 'Widowed',
      de: 'Verwitwet',
      fr: 'Veuve',
      it: 'Vedova',
    },
    value: 4,
  },
  {
    label: {
      en: 'Registered Partnership',
      de: 'Registrierte Partnerschaft',
      fr: 'Partenariat enregistré',
      it: 'Partenariato registrato\n',
    },
    value: 914650000,
  },
];
